import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./order_throttling_cap_duration.js";
//#region src/order_throttling_cap_duration_helper.ts
var order_throttling_cap_duration_helper_exports = /* @__PURE__ */ __exportAll({
	name: () => name,
	timeInterval: () => timeInterval
});
function name(orderThrottlingCapDuration) {
	switch (orderThrottlingCapDuration) {
		case "current-10-minute-interval": return "Current 10 minute interval";
		case "current-15-minute-interval": return "Current 15 minute interval";
		case "entire-time-interval": return "Entire time interval";
	}
}
function timeInterval(orderThrottlingCapDuration) {
	switch (orderThrottlingCapDuration) {
		case "current-10-minute-interval": return 10;
		case "current-15-minute-interval": return 15;
		case "entire-time-interval": throw new Error("No time interval for entire throttling interval.");
	}
}
//#endregion
export { name, order_throttling_cap_duration_helper_exports, timeInterval };

//# sourceMappingURL=order_throttling_cap_duration_helper.js.map